import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";

const RoleSelect = (props) => {
    return (
        <InputGroup>
            <Form.Select size={props.size} value={props.value} onChange={props.onChange}>
                <option value="member">ผู้ใช้</option>
                <option value="staff">เจ้าหน้าที่</option>
                <option value="admin">ผู้ดูแลระบบ</option>
            </Form.Select>
        </InputGroup>
    );
};

export default RoleSelect;
